import React from 'react';

export const ServiceRequestNavContext = React.createContext({
  serviceRequestNavigation: null,
  orderId: null,
  serviceRequestId: null,
  ticketNumber: null,
  requestNumber: null,
  previousGridPosition: {
    navigationOrigin: null,
    windowScrollOffset: null,
    dataState: null,
    selectedAnnex: null,
    savedQuickSearch: null,
    selectedUnit: null
  },
  setServiceRequestNavigation: () => {},
  setServiceRequestId: () => {},
  setOrderId: () => {},
  setPreviousGridPosition: () => {},
  clearPreviousPosition: () => {},
  clearSelectedAnnex: () => {},
  clearSavedQuickSearch: () => {},
  clearSavedDataState: () => {},
  clearSelectedUnit: () => {},
  setTicketNumber: () => {},
  setRequestNumber: () => {}
});
